import { T } from "@tldraw/validate";
const opacityValidator = T.unitInterval;
export {
  opacityValidator
};
//# sourceMappingURL=TLOpacity.mjs.map
